/* eslint-disable */
import axios from '@/shared/utils/axios-init';

const initialState = {
  statusCode: null,
  rejectionReason: null,
  verificationData: {},
};

const getters = {
  pending: (state) => {
    const status = state.statusCode === 0;
    const completed = state.verificationData.docPhotos.length > 0;

    return status && completed;
  },
  isConfirmed: (state) => state.statusCode === 1,
  isRejected: (state) => state.statusCode === 2,
};

const actions = {
  async fetchVerificationData({ commit, dispatch }) {
    try {
      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');

      const {
        data: { success, userdoc },
      } = await axios.get('cabinet/docs', {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!success) throw new Error('Something went wrong');

      await dispatch('updateVerificationData', userdoc);
      return success;
    } catch (err) {
      console.error(err);
    }
  },

  async sendVerificationData({ dispatch }, credentials) {
    try {
      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');

      const formData = new FormData();

      Object.entries(credentials).forEach(([key, value], idx) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item instanceof Blob) {
              item = new File(
                [item],
                String(Math.random()).substr(2) + '.jpg',
                {
                  type: item.type,
                }
              );
            }

            formData.append(`${key}[]`, item);
          });
        } else {
          formData.append(key, value);
        }
      });

      const { data } = await axios.post('cabinet/docs', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          boundary: Math.random().toString().substr(2),
          'Content-Type': 'multipart/form-data',
        },
      });

      await dispatch('updateVerificationData', data.userdoc);
      return data;
    } catch (err) {
      return { error: err.message };
    }
  },

  async createFilesFromUrlsArray(_, urls = []) {
    const token =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    const files = [];

    for (let url of urls) {
      const response = await fetch(
        `${process.env.ROOT_API}/api/cabinet/docs/get`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
          },
          body: JSON.stringify({ userdoc: url }),
        }
      );

      const blob = await response.blob();
      files.push(blob);
    }

    return files;
  },

  async updateVerificationData({ commit, dispatch }, data) {
    const updatedData = {
      name: data.name,
      surname: data.surname,
      patronymic: data.patronymic,
      birthday: data.birthday,
      country: data.country,
      docType: data.docdata.docType,
      issueDate: data.docdata.issueDate,
      serialNumber: data.docdata.serialNumber,
      validUntil: data.docdata.validUntil,
      selfie: await dispatch('createFilesFromUrlsArray', data.docdata.selfie),
      docPhotos: await dispatch(
        'createFilesFromUrlsArray',
        data.docdata.docPhotos
      ),
    };

    commit('setRejectionReason', data.docdata.rejectionReason);
    commit('setStatusCode', data.doc_confirmed);
    commit('setVerificationData', updatedData);
  },
};

const mutations = {
  setVerificationData(state, payload) {
    state.verificationData = payload;
  },
  setStatusCode(state, payload) {
    state.statusCode = payload;
  },
  setRejectionReason(state, payload) {
    state.rejectionReason = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/verification.js